<div>
	<button
		nbButton
		status="success"
		(click)="approval()"
		*ngIf="isApproval"
		class="mr-3"
		[size]="layout === 'CARDS_GRID' ? 'tiny' : 'medium'"
	>
		{{ 'APPROVAL_REQUEST_PAGE.APPROVE' | translate }}
	</button>
	<button
		nbButton
		status="danger"
		(click)="refuse()"
		*ngIf="isRefuse"
		[size]="layout === 'CARDS_GRID' ? 'tiny' : 'medium'"
	>
		{{ 'APPROVAL_REQUEST_PAGE.REFUSE' | translate }}
	</button>
</div>
